export const pricingData = {
	yearly: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$40",
			salePrice: "$25",
			link: "https://pickplugins.lemonsqueezy.com/checkout/buy/e8d33f98-b84e-480a-a422-bc175af6ada9?enabled=270427&checkout%5Bcustom%5D%5Bproduct_id%5D=3935",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$99",
			salePrice: "$75",
			link: "https://pickplugins.lemonsqueezy.com/checkout/buy/98b2b146-9ed0-4d97-b0ad-ee54b762f799?enabled=270430&checkout%5Bcustom%5D%5Bproduct_id%5D=3934",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$199",
			salePrice: "$150",
			link: "https://pickplugins.lemonsqueezy.com/checkout/buy/365ae069-9604-4a4c-b83c-12a315df8b38?enabled=270434&checkout%5Bcustom%5D%5Bproduct_id%5D=3933",
		},
	],
	lifetime: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$99",
			salePrice: "$80",
			link: "https://pickplugins.lemonsqueezy.com/checkout/buy/6d25c9ad-d2af-4732-b8cd-2716a961e6d0?enabled=270429&checkout%5Bcustom%5D%5Bproduct_id%5D=37934",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$199",
			salePrice: "$160",
			link: "https://pickplugins.lemonsqueezy.com/checkout/buy/47471695-88ef-40ad-80b8-da6853929627?enabled=270431&checkout%5Bcustom%5D%5Bproduct_id%5D=37933",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$299",
			salePrice: "$240",
			link: "https://pickplugins.lemonsqueezy.com/checkout/buy/76616a32-9e29-481a-8344-ece4686b3718?enabled=270435&checkout%5Bcustom%5D%5Bproduct_id%5D=37935",
		},
	],
};
